module.exports = __webpack_public_path__ + "static/media/traycorp16.3beb31dd.png";